module.exports = __webpack_public_path__ + "static/p_two.6388190e.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/p_two.png
// module id = 971
// module chunks = 8